import axios from "axios";
import { getAppBaseURL } from "./networkUtil";

const API_URLS = "/api/v1/";
const AXIOS_TIMEOUT = { timeout: 15 * 1000 * 60 };
const SERVER_BASE_URL = process.env.REACT_APP_URL + "/advisor/uf/api/v1/";

const validateStatusFn = function (status) {
  return status >= 200 && status <= 422; // Treat status codes 200-299 as successful
};

const AxiosInstance = axios.create({
  baseURL: `${SERVER_BASE_URL}`,
  timeout: AXIOS_TIMEOUT,
  validateStatus: validateStatusFn,
});

AxiosInstance.interceptors.request.use((config) => {
  config.baseURL = getAppBaseURL();
  return config;
});

AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        const redirectUrl = `${
          process.env.REACT_APP_AUTH_ENDPOINT
        }?response_type=code&client_id=${
          process.env.REACT_APP_CONSUMER_KEY
        }&redirect_uri=${encodeURIComponent(
          process.env.REACT_APP_REDIRECT_URI
        )}`;
        // Redirect to the login page
        window.location.href = redirectUrl;
      }
    }

    return Promise.reject(error);
  }
);

export const AxiosInstanceWithoutTimeout = axios.create({
  baseURL: `${getAppBaseURL()}${API_URLS.apiVersion}`,
});

export default AxiosInstance;
